import { EvPlugType2Icon } from './EvPlugType2Icon';

/**
 * author: Michael Irigoyen
 * id F5687378-A23D-4D4C-98A2-55E95642FD06
 * name ev-plug-type2
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ev-plug-type2.svg
 * tags
 * - Automotive 
 */
export const EvPlugMennekesIcon = EvPlugType2Icon;
export default EvPlugMennekesIcon